import CtaButton from './CtaButton';
import './ServicesDetail.css';

const DETAIL_IMG =
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=1000&q=80';

export default function ServicesDetail() {
  return (
    <section className="section services-detail">
      <div className="container services-detail-grid">
        <div className="services-detail-image">
          <img src={DETAIL_IMG} alt="GPS device showing detailed navigation map" loading="lazy" />
        </div>
        <div>
          <h2 className="section-title">GPS Maps Update</h2>
          <p>
            Map updates bring new roads, corrected routes, refreshed points of interest, and improved turn-by-turn
            performance. Whether your device uses SD cards, USB connection, or Wi-Fi sync, we help you choose the
            correct update package and complete installation safely.
          </p>
          <p>
            Regular updates reduce wrong turns, missing exits, and outdated destination data — especially important
            for commercial drivers and marine navigation where accuracy matters most.
          </p>
          <CtaButton className="btn btn-primary">Get Map Update Assistance</CtaButton>
        </div>
      </div>
    </section>
  );
}
